/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Qbank_Role_PlaceholderInputs */

const en_interview_qbank_role_placeholder = /** @type {(inputs: Interview_Qbank_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Software Engineer, Product Manager, Data Scientist...`)
};

const de_interview_qbank_role_placeholder = /** @type {(inputs: Interview_Qbank_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Software Engineer, Product Manager, Data Scientist...`)
};

const fr_interview_qbank_role_placeholder = /** @type {(inputs: Interview_Qbank_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. Software Engineer, Product Manager, Data Scientist...`)
};

const es_interview_qbank_role_placeholder = /** @type {(inputs: Interview_Qbank_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. Software Engineer, Product Manager, Data Scientist...`)
};

const it_interview_qbank_role_placeholder = /** @type {(inputs: Interview_Qbank_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. Software Engineer, Product Manager, Data Scientist...`)
};

const nl_interview_qbank_role_placeholder = /** @type {(inputs: Interview_Qbank_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bijv. Software Engineer, Product Manager, Data Scientist...`)
};

const pl_interview_qbank_role_placeholder = /** @type {(inputs: Interview_Qbank_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`np. Software Engineer, Product Manager, Data Scientist...`)
};

const fi_interview_qbank_role_placeholder = /** @type {(inputs: Interview_Qbank_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`esim. ohjelmistokehittäjä, tuotepäällikkö, data-analyytikko...`)
};

const da_interview_qbank_role_placeholder = /** @type {(inputs: Interview_Qbank_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`f.eks. softwareudvikler, produktchef, dataanalytiker...`)
};

const sv_interview_qbank_role_placeholder = /** @type {(inputs: Interview_Qbank_Role_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`t.ex. mjukvaruutvecklare, produktchef, dataanalytiker...`)
};

/**
* | output |
* | --- |
* | "e.g. Software Engineer, Product Manager, Data Scientist..." |
*
* @param {Interview_Qbank_Role_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_qbank_role_placeholder = /** @type {((inputs?: Interview_Qbank_Role_PlaceholderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Qbank_Role_PlaceholderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_qbank_role_placeholder(inputs)
	if (locale === "fr") return fr_interview_qbank_role_placeholder(inputs)
	if (locale === "es") return es_interview_qbank_role_placeholder(inputs)
	if (locale === "it") return it_interview_qbank_role_placeholder(inputs)
	if (locale === "nl") return nl_interview_qbank_role_placeholder(inputs)
	if (locale === "pl") return pl_interview_qbank_role_placeholder(inputs)
	if (locale === "fi") return fi_interview_qbank_role_placeholder(inputs)
	if (locale === "da") return da_interview_qbank_role_placeholder(inputs)
	if (locale === "sv") return sv_interview_qbank_role_placeholder(inputs)
	return en_interview_qbank_role_placeholder(inputs)
});